<template>
  <div :class="classes.wrapper">
    <div :class="classes.inner">
      <Header />
      <Content />
    </div>

    <Footer :class="classes.footer" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import Header from "../../HeaderInternal.vue";
import Footer from "../../Footer.vue";
import Content from "../../Content.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import {
  injectBrand,
  BrandContext
} from "@fresh8/ad-data-composition/src/brand";

export default defineComponent({
  name: "MobileLeaderboard",
  components: {
    Header,
    Content,
    Footer
  },
  setup() {
    const { teamBranding, footerBranding } =
      injectBrand() || ({} as BrandContext);

    const footerEmpty = computed(
      () =>
        !footerBranding.value?.static?.value?.length &&
        !footerBranding.value?.value?.length &&
        !footerBranding.value?.scrolling?.value?.length
    );

    const reativeStyles = computed(() => ({
      footerEmpty: footerEmpty.value,
      teamBranding: teamBranding.value.useTeamBranding
    }));
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const classes = useStyles(reativeStyles);

    return {
      useTeamBranding: computed(() => teamBranding.value.useTeamBranding),
      classes
    };
  }
});

const useStyles = createUseStyles({
  inner: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    height: "40px"
  },
  wrapper: {
    flex: 1,
    display: "flex",
    height: "100%",
    flexDirection: "column",
    boxSizing: "border-box"
  },
  header: {
    display: "grid"
  },
  footer: {
    // padding: "1px",
    height: "10px",
    boxSizing: "border-box"
  }
});
</script>
